<template>
    <div class="filesWrap max-content">
        <top :title="title" :color="color"></top>
        <div class="file-list">
            <div v-for="(item, index) in fileList" :key="index">
                <!-- <router-link :to="{path:'/meeting/live',query:{'id':item.id,'meeting_id':item.meeting_id}}">	 -->
                <div class="info">
                    <h4>{{ item.title }}</h4>
                    <div>
                        <p>{{ item.file_size }}</p>
                        <p>{{ item.created_at }}</p>
                    </div>
                </div> 
                <div class="skip" @click="sendFile(item)">
                    <img src="../../../assets/images/Meeting/Meeting_download.png" alt="">
                </div>

                <!-- </router-link>		 -->
            </div>
        </div>
        <van-popup style="width:320px;padding:30px 20px 15px;border-radius: 5px;" v-model="showEmail" position="center"
            @close="showEmail = false">
            <van-cell-group>
                <van-field v-model="email" placeholder="请输入邮箱">
                </van-field>
            </van-cell-group>

            <div class="buttonGroup" ref='buttonGroup'>
                <van-button type="default" @click="submit">确定</van-button>

            </div>
        </van-popup>
    </div>
</template>
<script>
import { ButtonDetail, UpdateUserInfo, SendFileEmail } from '../../../config/interface.js'
import Top from "../components/Top";
import { Toast } from 'vant'
export default {
    components: {
        Top
    },
    data() {
        return {
            meeting_id: 0,
            date: '',
            fileList: [],
            meeting_id: this.$route.query.meeting_id ? this.$route.query.meeting_id : this.$route.query.MT_id,
            button_id: this.$route.query.button_id ? this.$route.query.button_id : this.$route.query.b_id,
            pptList: [],
            title: '',
            color: '#FFFFFF',
            email: null,
            showEmail: false,
            fileInfo: {},
            flag :false
        }

    },
    mounted() {
        // if(this.$route.query.meeting_id==531 && this.$route.query.button_id==2484){
        //     window.open('https://cdn.edstatic.com/203012120000/dad828f7e0dbb56902422caf441d7968/2025/05/a96c7e04-478a-4854-8548-c92603c89c03.pdf','_blank')
        // }
        this.meeting_id = this.$route.query.meeting_id;
        this.date = this.$route.query.date;
        this.getButtonData();
        
    },
    methods: {
        goTo(url) {
            window.location.href = url;
        },
        sendFile(item) {
            this.fileInfo = item
            if(this.$route.query.meeting_id==531 && this.$route.query.button_id==2484){
                window.open('https://cdn.edstatic.com/203012120000/dad828f7e0dbb56902422caf441d7968/2025/05/a96c7e04-478a-4854-8548-c92603c89c03.pdf','_blank');
                return;
            }


       
            if (this.email && this.email.length ) {

                let params = {
                    email: this.email,
                    file_url: item.url,
                    file_name: item.title
                }
                const method = "POST";
                console.log(SendFileEmail)
                fetch(SendFileEmail, params, method)
                    .then((res) => {
                        if (res.code == 0) {
                            Toast('下载链接将发送至邮箱');
                        } else {
                            Toast(res.data.error_msg);

                        }
                    })

            } else {
                this.showEmail = true;
            }
        },

        submit() {
            let that = this
            if (this.email) {
                var emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
                if (!emailRegex.test(this.email)) {
                    Toast('邮箱格式错误!');
                    return;
                }
                let params = {
                    email: this.email
                }
                const method = "POST";
                fetch(UpdateUserInfo, params, method)
                    .then((res) => {
                        if (res.code == 0) {
                            this.showEmail = false;
                            setTimeout(() => {
            
                                that.sendFile(that.fileInfo)
                                // Toast('设置成功');
                            }, 200)
                        }
                    })
            }

        }
        ,        //获取文件信息
        getButtonData() {
            if (this.button_id) {
                const url = ButtonDetail;
                let params = {
                    button_id: this.button_id
                }
                const method = "POST";
                fetch(url, params, method)
                    .then((res) => {
                        if (res.code == 0) {
                            document.title = res.data.share_title;
                            this.title = res.data.name;
                            if (res.data.email && res.data.email.length) {
                                this.email = res.data.email

                            }
                            if (res.data.downloadFiles) {
                                this.fileList = res.data.downloadFiles
                            }
                            if (res.data.theme_color_hex) {
                                this.color = res.data.theme_color_hex
                            } else {
                                this.color = '#901D22'
                            }
                            if (common.is_weixin()) {
                                let data = res.data;
                                common.wxShare(data.share_title, data.share_sub_title, data.share_img);
                            }
                        }
                    })

            }
        }

    }
}
</script>
<style lang="scss">
.filesWrap {
    position: relative;
    min-height: 100%;

    .file-list {
        padding: 0 15px;

    }

    .file-list>div {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        border-bottom: 1px solid #dfdfdf;
        padding: 10px 0;
    }

    .file-list .info {
        display: flex;
        flex-direction: column;

        div {
            display: flex;
            align-items: center;
        }

        p {
            color: #999;
            margin-right: 10px;
            font-size: 12px;
        }
    }

    .skip {
        width: 30px;
        height: 30px;
        flex-shrink: 0;

        img {
            width: 100%;
            height: 100%;
        }

    }

    h4 {
        font-size: 11px;
        color: $color-black;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        white-space: wrap;
        margin-right: 10px;
        margin-bottom: 10px;

    }
}

.buttonGroup {
    width: 100%;
    display: flex;
    justify-content: space-around;
    margin-top: 20px;

    button {
        width: 134px;
        height: 40px;
        color: #fff;
        background: rgba(154, 154, 154, 1);
        border-radius: 23px;
        font-size: 17px;
    }

    button:last-child {
        background: #901D22;
    }
}

.van-cell-group {
    display: flex;
    align-items: center;
    font-size: 15px;
    margin-bottom: 15px;

    .van-cell {
        // border:1px solid #ddd;
        background: rgba(86, 86, 86, 0.03);
        border-radius: 10px;
        padding: 10px 15px;
    }

    .van-cell:not(:last-child)::after {
        border: 0px;
    }
}

.van-cell-group:after {
    border: 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/VascularSystem/Meeting/Files.vue